import React from "react";

import AnimateIconShield from "../icons/animate-icon-shield.jsx";
import AnimateIconTarget from "../icons/animate-icon-target.jsx";
import AnimateIconClock from "../icons/animate-icon-clock.jsx";
import AnimateIconBacteria from "../icons/animate-icon-microbes.jsx"

import sectionImg from "../images/section-image-provider.jpg"
import sectionImgMobile from "../images/section-image-provider-mobile.jpg"
import video1 from "../images/Video-1-screenshot.jpg"

import ResourcesCarousel from './ResourcesCarousel.jsx';
import Form from "./Form.jsx";

function Provider() {

  return (
    <div>
      <div className="banner provider img-fluid">
        <div className="container m-padding banner-padding">
          <div className="row">
            <div className="col-md-7 col-sm-6"></div>
            <div className="col-md-5 col-sm-6">
              <h2 className="preheader fw-bold color-1 compatil-bold">Information for Providers</h2>
              <h1 className="display-3 fw-bold color-1 compatil-bold mb-3"><span className="no-break">The Benefits of</span> <span className="color-2">Chlorhexidine</span></h1>
              <h3 className="fw-bold color-1 compatil-bold desktop">Chlorhexidine is a broad&#8209;spectrum biocide effective against Gram&#8209;positive bacteria, Gram&#8209;negative bacteria, fungi, and yeast.</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container mobile">
        <div className="row pt-5 pb-5">
          <div className="col-md-6 col-sm-6">
            <h2 className="fw-bold color-1 compatil-bold text-center">Chlorhexidine is a broad&#8209;spectrum biocide effective against Gram&#8209;positive bacteria, Gram&#8209;negative bacteria, fungi, and yeast.</h2>
          </div>
        </div>
      </div>

      <div className="container max">
        <div className="row grey-hov">
          <div className="icon-hover flex-v col-md-6 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconShield />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Protects against<br></br> microbial colonization<sup>1</sup></strong></h3>
                <h3 className="color-1 open-sans state-2">Chlorhexidine kills organisms<br></br> and <strong>protects against microbial<br></br> colonization</strong> and, subsequently,<br></br> biofilm development.<sup>1</sup></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Protects against microbial<br></br> colonization<sup>1</sup></strong></h3>
                <h3 className="color-1 open-sans min no-margin state-2">Chlorhexidine kills organisms and <strong>protects against microbial colonization</strong> and, subsequently, biofilm development.<sup>1</sup></h3>
              </div>
            </div>
          </div>
          <div className="icon-hover flex-v col-md-6 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconTarget />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Broader spectrum<br></br> than antibiotics<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans state-2">And has a <strong>faster kill rate</strong><br></br> than other antimicrobials<br></br> (eg, povidone-iodine).<sup>2</sup></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Broader spectrum<br></br> than antibiotics<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans min no-margin state-2">And has a <strong>faster kill rate</strong> than other<br></br> antimicrobials (eg, povidone-iodine).<sup>2</sup></h3>
              </div>
            </div>
          </div>
          <div className="icon-hover flex-v col-md-6 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconClock />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Bacterial uptake typically<br></br> within 20 seconds<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans state-2">Chlorhexidine kills <strong>by<br></br> distrupting the cell<br></br> membrane.</strong><sup>3</sup></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Bacterial uptake typically<br></br> within 20 seconds<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans min no-margin state-2">Chlorhexidine kills <strong>by distrupting<br></br> the cell membrane.</strong><sup>3</sup></h3>
              </div>
            </div>
          </div>
          <div className="icon-hover flex-v col-md-6 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconBacteria />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Destroys main<br></br> categories of microbes<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans state-2"><strong>Limited risk</strong> for the<br></br> development of an<br></br> opportunistic infection.<sup>2</sup></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Destroys main<br></br> categories of microbes<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans min no-margin state-2"><strong>Limited risk</strong> for the development<br></br> of an opportunistic infection.<sup>2</sup></h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-section section-bg img-fluid flex-v">
        <div className="container m-padding pad-m-y">
          <div className="row flex-v">
            <div className="col-md-4 col-sm-6">
              <h2 className="fw-bold compatil-bold text-white mb-5">When you think<br></br> Infection Prevention, think Arrowg+ard Blue Plus™ Technology</h2>
              <h3 className="open-sans min color-1"><strong>CLABSI Reduction</strong></h3>
              <h4 className="open-sans text-white desktop">Arrowg+ard Blue Plus™ Catheters are proven to <strong>reduce central line&#8209;associated bloodstream infection (CLABSI) by 67% to 100%.</strong><sup>4-7</sup></h4>
              <h4 className="open-sans min text-white mobile">Arrowg+ard Blue<br></br> Plus™ Catheters<br></br> are proven to<br></br> <strong>reduce central<br></br> line&#8209;associated<br></br> bloodstream<br></br> infection (CLABSI)<br></br> by 67% to 100%.</strong><sup>4-7</sup></h4>
            </div>
            <div className="col-md-3 offset-md-5 desktop">
              <h3 className="open-sans color-2"><strong>Evidence-Based</strong></h3>
              <h4 className="open-sans text-white mb-5">Proven effective against common antibiotic-resistant microorganisms and supported by <strong> 30+ clinical studies.</strong><sup>8,9</sup></h4>
            </div>
            <div className="col-md-3 offset-md-5 pt-5 mobile">
              <h3 className="open-sans min color-2 pt-5"><strong>Evidence-Based</strong></h3>
              <h4 className="open-sans min text-white mb-5">Proven effective against<br></br> common antibiotic-resistant<br></br> microorganisms and supported<br></br> by <strong> 30+ clinical studies.</strong><sup>8,9</sup></h4>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row pad-m-y">
          <h2 className="fw-bold compatil-bold color-1 text-center mb-5 m-padding">See Arrowg+ard Blue Plus<sup>&trade;</sup> Protection in Action<sup>10,11</sup></h2>
          <div className="video-container">
            <video controls width="100%" poster={video1}>
              <source src="https://player.vimeo.com/progressive_redirect/playback/908718853/rendition/1080p/file.mp4?loc=external&log_user=0&signature=2fe6233abd5a9442fa76bdb1a0e229658d82af494598a597d7df5456af5c36f1" title="AGBPlus-Biofilm_FINAL" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div className="container max desktop bg-grey">
        <div className="row">
          <div className="bg-grey split-width flex-v">
            <div className="split-text-col col-md-7 offset-md-3 offset-sm-0 pb-5">
              <h2 className="open-sans color-2 pb-2"><strong>Your Vascular<br></br> Access Partner</strong></h2>
              <h4 className="open-sans md color-1 pb-2">At Teleflex, we share your<br></br> commitment to patient safety.</h4>
              <ul className="open-sans color-1 mb-5">
                <h5><li>We’re your partner in vascular access, working to provide the most up-to-date information on 
                  <a className="blue-link" href="./#hob"> <u>changing guidelines</u> </a>
                  to ensure your teams are prepared</li></h5>
                <h5><li>We work with you to provide hands-on training, bedside coaching, and metrics for success</li></h5>
              </ul>
              <a href="./information" target="_blank" className="btn btn-primary btn-md" type="button">Chlorhexide Sensitivity Information</a>
            </div>
          </div>
          <div className="col-md-6 col-sm-6">
            <img src={sectionImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container max mobile">
        <div className="row bg-grey">
          <div className="col-md-6">
            <img src={sectionImgMobile} alt="" className="img-fluid" />
          </div>
          <div className="col-md-6 pb-5 pad-m-y">
            <h2 className="open-sans color-2 pb-2 m-padding"><strong>Your Vascular<br></br> Access Partner</strong></h2>
            <h4 className="open-sans min md color-1 pb-2 m-padding">At Teleflex, we share your<br></br> commitment to patient safety.</h4>
            <ul className="open-sans color-1 mb-5">
              <h5 className="open-sans m-padding">
                <li>We’re your partner in vascular access, working to provide the most up-to-date information on
                  <a className="blue-link" href="./#hob"> <u>changing guidelines</u> </a>
                   to ensure your teams are prepared</li>
              </h5>
              <h5 className="open-sans m-padding"><li>We work with you to provide hands-on training, bedside coaching, and metrics for success</li></h5>
            </ul>
            <div className="text-center">
              <a href="./information" target="_blank" className="btn btn-primary btn-md" type="button">Chlorhexide Sensitivity Information</a>
            </div>
          </div>
        </div>
      </div>

      <ResourcesCarousel />
      <Form />
      {/* references */}
      <div className="references container pb-5">
        <div className="row pt-5 ref-text open-sans color-3">
          <p>References:
            <ol>
              <li>Mohammadi Z, Abbott PV. The properties and applications of chlorhexidine in endodontics. <i>Int Endod J</i>. 2009;42(4):288-302. doi:10.1111/j.1365-2591.2008.01540.x</li>
              <li>McDonnell G, Russell AD. Antiseptics and disinfectants: activity, action, and resistance. <i>Clin Microbiol Rev</i>. 1999;12(1):147-179. doi:10.1128/CMR.12.1.147</li>
              <li>Mangram AJ, Horan TC, Pearson ML, Silver LC, Jarvis WR. Guideline for prevention of surgical site infection, 1999. Centers for Disease Control and Prevention (CDC) Hospital Infection Control Practices Advisory Committee. <i>Am J Infect Control</i>. 1999;27(2):97-96.</li>
              <li>Rupp ME, Lisco SJ, Lipsett PA, et al. Effect of a second-generation venous catheter impregnated with chlorhexidine and silver sulfadiazine on central catheter-related infections: a randomized, controlled trial. <i>Ann Intern Med</i>. 2005;143(8):570-580. doi:10.7326/0003-4819-143-8-200510180-00007</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Chlorhexidine-silver sulfadiazine-impregnated venous catheters save costs. <i>Am J Infect Control</i>. 2014;42(3):321-324. doi:10.1016/j.ajic.2013.09.022</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Cost/benefit analysis of chlorhexidine-silver sulfadiazine-impregnated venous catheters for femoral access. <i>Am J Infect Control</i>. 2014;42(10):1130-1132. doi:10.1016/j.ajic.2014.06.027</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Chlorhexidine-silver sulfadiazine-impregnated venous catheters are efficient even at subclavian sites without tracheostomy. <i>Am J Infect Control</i>. 2016;44(12):1526-1529. doi:10.1016/j.ajic.2016.04.236</li>
              <li>Arrowg+ard Blue Protection Clinical References. MC-004390. Available from Teleflex.</li>
              <li>Arrowg+ard Blue Plus Protection Clinical References. MC-004391. Available from Teleflex.</li>
              <li>Mermel LA. What is the evidence for intraluminal colonization of hemodialysis catheters?. <i>Kidney Int</i>. 2014;86(1):28-33. doi:10.1038/ki.2013.527</li>
              <li>O’Grady NP, Alexander M, Burns LA, et al; Healthcare Infection Control Practices Advisory Committee (HICPAC). Guidelines for the prevention of intravascular catheter-related infections, 2011. CDC. Updated October 2017. Accessed January 29, 2024. <a href="https://www.cdc.gov/infectioncontrol/pdf/guidelines/bsi-guidelines-H.pdf" target="_blank" rel="noopener noreferrer">https://www.cdc.gov/infectioncontrol/pdf/guidelines/bsi-guidelines-H.pdf</a></li>
            </ol>
          </p>
          <p className="pb-3">Rx Only</p>
          <p>Contraindications:</p>
          <p className="pb-4">The Arrowg+ard Blue™ and Arrowg+ard Blue Plus™ Catheters are contraindicated for patients with known hypersensitivity to chlorhexidine, silver sulfadiazine and/or sulfa drugs.</p>
          <p className="sm">Teleflex, the Teleflex logo, Arrow, Arrowg+ard Blue and Arrowg+ard Blue Plus are trademarks of Teleflex Incorporated or its affiliates, in the U.S. and/or other countries. All other trademarks are trademarks of their respective owners. MC-008512</p>
        </div>
      </div>

    </div>
  );
}

export default Provider;
